export {default} from './ChangePassword';



// WEBPACK FOOTER //
// ./src/pages/ChangePassword/index.ts